import { render, staticRenderFns } from "./YcGuanLi.vue?vue&type=template&id=2f8579d4&scoped=true"
import script from "./YcGuanLi.vue?vue&type=script&lang=js"
export * from "./YcGuanLi.vue?vue&type=script&lang=js"
import style0 from "./YcGuanLi.vue?vue&type=style&index=0&id=2f8579d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8579d4",
  null
  
)

export default component.exports